/**
 * @file UserLoginFormWithImageImageSlot.tsx
 *
 * @fileOverview This slot can be used to render custom things on the side
 * where the image is rendered. For example custom text over the image. Content
 * of this slot has position absolute and is centered in the middle of image
 * by default from component library.
 *
 */

export const UserLoginFormWithImageImageSlot = () => {
  return null;
};

export default UserLoginFormWithImageImageSlot;
